<div class="row">
  <div class="col-sm-12 bloccodati">
    <p><label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span></p>
  </div>
</div>
